import React from "react";
import MetaTags from 'react-meta-tags';

function Activity() {
	// feature-newapp
	return (
		<div className="content_inpage">
			<MetaTags>
				<title>中華電信i寶貝智慧音箱-活動專區</title>
				<meta name="keywords" content="i寶貝活動,愛粉打卡,愛粉說起來"></meta>
				<meta name="description" content="i寶貝智慧音箱的打卡活動-愛粉說起來，每兩個月都會有指定任務、打卡累積hami point並抽大獎喔!" />
				<meta property="og:title" content="中華電信i寶貝智慧音箱-活動專區" />
				<meta property="og:Description" content="i寶貝智慧音箱的打卡活動-愛粉說起來，每兩個月都會有指定任務、打卡累積hami point並抽大獎喔!" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_496bf11d-5c35-41c7-b18c-894e7331f961.png" />
			</MetaTags>
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/campaign/activity">活動專區</a></li>
				</ul>
				<h2 className="tit_main">活動專區</h2>
				<div className="content_box activity_box">
					<div className="cb_set">
						<div className="ab_box">
							<h3 className="tit_sec">新客快閃活動<span>2024/01/11~2024/01/20</span></h3>
							<div className="ab_img"><img src={require("../../image/DoubleDay_1280x500.jpg").default} alt="DoubleDay" /></div>
							<a href="/container/commodity"> </a>
						</div>
						<div className="ab_box">
							<h3 className="tit_sec">新客快閃活動<span>2023/12/01~2023/12/31</span></h3>
							<div className="ab_img"><img src={require("../../image/DoubleDay12_1280x500.jpg").default} alt="DoubleDay12" /></div>
							<a href="/container/commodity"> </a>
						</div>
						<div className="ab_box">
							<h3 className="tit_sec">新客快閃活動<span>2023/11/11~2023/11/20</span></h3>
							<div className="ab_img"><img src={require("../../image/DoubleDay11_1280x500.jpg").default} alt="DoubleDay11" /></div>
							<a href="/container/commodity"> </a>
						</div>
						<div className="ab_box">
							<h3 className="tit_sec">新客快閃活動<span>2023/10/10~2023/10/19</span></h3>
							<div className="ab_img"><img src={require("../../image/DoubleDay10_1280x500.jpg").default} alt="DoubleDay10" /></div>
							<a href="/container/commodity"> </a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Activity;